var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-dark-mode-switch"},[_c('f-toggle-button',{attrs:{"title":_vm.title,"aria-label":_vm.title},model:{value:(_vm.darkModeOn),callback:function ($$v) {_vm.darkModeOn=$$v},expression:"darkModeOn"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }